import {Box, Button, Container, Typography, useMediaQuery} from "@mui/material";
import {useNavigate} from "react-router-dom";

export function HeroImage() {
    const navigate = useNavigate();
    const minWidth = useMediaQuery("(min-width:1200px)");

    return (
        <Box className={"Hero"}>
            {minWidth && <Box className={"HeroText"} sx={{width: {xs: '70%', sm: '60%', md: '60%'}}}>
                <Container maxWidth={"lg"}>
                    <Typography sx={{
                        fontFamily: 'Barlow',
                        fontSize: '40px',
                        fontStyle: 'normal',
                        fontWeight: '700',
                        textTransform: "uppercase",
                        color: "white",
                        backgroundColor: "#E19117",
                        width: "fit-content",
                        padding: 1,
                        borderRadius: "10px"
                    }}>Welkom bij MiniMax</Typography>
                    <Typography sx={{
                        fontFamily: 'Barlow',
                        fontSize: '72px',
                        fontStyle: 'normal',
                        fontWeight: '900',
                        color: "white"
                    }}>Een frisse knipbeurt voor je viervoeter.</Typography>
                    <Button sx={{
                        fontFamily: 'Barlow',
                        fontSize: '20px',
                        fontStyle: 'normal',
                        fontWeight: '500',
                        color: "white"
                    }} onClick={() => navigate("/contact")}>Boek nu je afspraak</Button>
                </Container>
            </Box>}

            {!minWidth &&
                <Box className={"HeroText"} sx={{width: {xs: '70%', sm: '60%', md: '60%'}}}>
                    <Container maxWidth={"lg"}>
                        <Typography sx={{
                            fontFamily: 'Barlow',
                            fontSize: '20px',
                            fontStyle: 'normal',
                            fontWeight: '700',
                            textTransform: "uppercase",
                            color: "white",
                            backgroundColor: "#E19117",
                            width: "fit-content",
                            padding: 1,
                            borderRadius: "10px"
                        }}>Welkom bij MiniMax</Typography>
                        <Typography sx={{
                            fontFamily: 'Barlow',
                            fontSize: '20px',
                            fontStyle: 'normal',
                            fontWeight: '900',
                            color: "white"
                        }}>Een frisse knipbeurt voor je viervoeter.</Typography>
                        <Button sx={{
                            fontFamily: 'Barlow',
                            fontSize: '10px',
                            fontStyle: 'normal',
                            fontWeight: '500',
                            color: "white"
                        }} onClick={() => navigate("/contact")}>Boek nu je afspraak</Button>
                    </Container>
                </Box>
            }
        </Box>
    );
}